/**
 * Created by Ning Jiang on 11/17/2016.
 */
///<reference path="../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomEase.d.ts"/>
///<reference path="../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomBounce.d.ts"/>
///<reference path="../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomWiggle.d.ts"/>

require("../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomEase.js");
require("../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomBounce.js");
require("../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomWiggle.js");

import ("pixi.js");
declare global {
    interface Window {
        PIXI:any;
        NolimitLauncher: NolimitLauncher;
    }
}
import * as PIXI from "pixi.js";
window.PIXI = PIXI;
require("pixi-spine");

import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {SanGameModuleConfig} from "./game/SanGameModuleConfig";
import {SanIntroConfig} from "./game/intro/SanIntroConfig";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {SanQuentin} from "./game/SanQuentin";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {SanQuentinPromoPanelConfig} from "./game/SanQuentinPromoPanelConfig";


window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.launch([
    new SanQuentin(SanGameModuleConfig.instance),
    new SlotKeypad(),
    new NolimitSlotAudio(),
    new NolimitPromotionPlugin(new SanQuentinPromoPanelConfig()),
    new NolimitGameIntroPlugin(new SanIntroConfig())]);



